// ScoreDonut — Cercle de progression minimaliste (tokens shadcn uniquement)

interface ScoreDonutProps {
  score: number
  maxScore: number
  size?: number
  strokeWidth?: number
  label?: string
}

export default function ScoreDonut({
  score,
  maxScore,
  size = 140,
  strokeWidth = 10,
  label = 'Score total',
}: ScoreDonutProps) {
  const percent = maxScore > 0 ? Math.round((score / maxScore) * 100) : 0
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const progressOffset = circumference - (percent / 100) * circumference

  return (
    <div className="flex flex-col items-center">
      <div className="relative w-full max-w-[160px] aspect-square">
        <svg
          viewBox={`0 0 ${size} ${size}`}
          className="w-full h-full -rotate-90"
        >
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke="var(--muted)"
            strokeWidth={strokeWidth}
          />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            className="stroke-primary"
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={progressOffset}
            strokeLinecap="round"
            style={{ transition: 'stroke-dashoffset 700ms ease-out' }}
          />
        </svg>

        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-2xl sm:text-3xl font-bold text-primary">
            {percent}%
          </span>
          <span className="text-xs text-muted-foreground mt-0.5">
            {score} / {maxScore}
          </span>
        </div>
      </div>
      <span className="mt-2 text-sm font-medium text-muted-foreground">{label}</span>
    </div>
  )
}
